
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jpg-to-pdf",
      function () {
        return require("private-next-pages/jpg-to-pdf.js");
      }
    ]);
  